export default __webpack_public_path__ + "static/ProdigySans-Medium-d558238401f0e0147151504ac359901e.woff2";